import { Linking } from 'react-native';

export const openAppSettings = () => {
  Linking.openSettings().catch((error) => {
    console.error('Failed to open location settings:', error);
  });
};
